module.exports = __webpack_public_path__ + "img/01_sub_no.de27aa48.svg";